/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Filter from './Components/Filter';
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';
import MonthFilter from './Components/MonthFilter';
import { dataService } from '../../../services/data.services';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
import Table from './Components/Table';
import ItemShimmer from '../../../components/Shimmer/itemShimmer';
import Pagination from '../../../components/Pagination';
import extractMonthYearInRange from '../../../CommonMethods/extractMonthYearInRange';
import GlobalContext from '../../../components/Context/GloablContext';
import Debounce from '../../../CommonMethods/Debounce';
import Loader from '../../../components/Loader';
import YearTable from './Components/YearTable';
import { addToTopCheckbox, resetState, selectAllStudents, addData } from './ModifyAttendance/StudentAttendanceSlice';
import { onSearchRows, limitReducer } from './ModifyAttendance/StudentAttendanceSlice';
import { useSelector, useDispatch } from 'react-redux'
import TextSection from '../../../components/ToolTip/TextSection';
import { StudentsAttendance } from './attendanceSlice';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import { motion } from "framer-motion";
import Toast from "../../../components/Toast";
import HolidayListDialog from './Components/HolidayListDialog';
const Attendance = ({ type }) => {
    const { isSideNavBar, setToastmessage, isInactiveBranch } = useContext(GlobalContext);

    const [toastErrorMessage,setToastErrorMessage] = useState('')
    const [searchParams, setSearchParams] = useSearchParams({ type: 'month' });
    const StudentsAttendanceList = useSelector(state => state.attendanceSlice)
    const { List } = StudentsAttendanceList
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [isMonthFilter, setIsMonthFilter] = useState(false)
    const [selectedAY, setSelectedAY] = useState({})
    const [loading, setLoading] = useState(false);
    const [recodes, setRecodes] = useState({});
    const [loadingExport, setLoadingExport] = useState(false);
    const [suggestions, setSuggestions] = useState("");
    const [hover, sethover] = useState('')
    const [selectedAYID, setSelectedAYID] = useState(searchParams.get("academic_year_id") === null ? '' : searchParams.get("academic_year_id"))
    const [selectedClassID, setSelectedClassID] = useState(searchParams.get("class_id") === null ? '' : searchParams.get("class_id"))
    const [selectedSectionID, setSelectedSectionID] = useState(searchParams.get("section_id") === null ? '' : searchParams.get("section_id"))
    const [selectedFilterParams, setSelectedFilterParams] = useState({
        academic_year: '',
        class: '',
        section: '',
    })
    const [selectedStaffFilterParams, setSelectedStaffFilterParams] = useState({
        academic_year : "",
        employee_type : ""
    })
    const [emptyScreenMessage, setEmptyScreenMessage] = useState('');
    const selectedRows = useSelector((state) => state.StudentsIdSlice.selectedRows.studentId)
    const studentIds = selectedRows.map((obj) => obj.id)
    const filterRef = useRef(null);
    const dispatch = useDispatch()
    const [isClearVisible, setClearVisible] = useState(false);
    const [isHolidayDialogOpen, setIsHolidayDialogOpen] = useState(false);
    /* The above code is using the `useOnClickOutside` hook in a React component. This hook takes two
    arguments: `filterRef` and a callback function. */
    useOnClickOutside(filterRef, () => {
        setIsFilterOpen(false)
    })
    const MonthFilterRef = useRef(null);
    /* The above code is using the `useOnClickOutside` hook in a React component. This hook is used to
    detect when a click event occurs outside of a specified element, in this case, the
    `MonthFilterRef` element. When a click event occurs outside of this element, the
    `setIsMonthFilter` function is called with the argument `false`, which presumably updates the
    state variable `isMonthFilter` to `false`. */
    useOnClickOutside(MonthFilterRef, () => {
        setIsMonthFilter(false)
    })
    /**
     * The function handleClearFilter sets the state variables isFilterOpen to false and
     * setSearchParams to an object with a type property set to 'month'.
     */
    const handleClearFilter = () => {
        setIsFilterOpen(false)
        setSearchParams({type : searchParams.get("type")})
        setRecodes({})
    }
    /**
     * The handleApply function sets the search parameters based on the selected filter parameters and
     * academic year.
     */
    const handleApply = (SectionId) => {
        const startDate = selectedAY.start_date === undefined ? searchParams.get("start_date") : selectedAY.start_date;
        const endDate = selectedAY.end_date === undefined ? searchParams.get("end_date") : selectedAY.end_date;

        let obj = type === "staff" ? {
            type : searchParams.get("type"),
            employee_type : selectedStaffFilterParams.employee_type,
            financial_year : selectedStaffFilterParams.financial_year,
            fy_status : searchParams.get("fy_status") === null ? selectedAY.status : searchParams.get("fy_status"),
            start_date : startDate,
            end_date : endDate,
            page_number : 1,
            limit : 10,
            filter : true
        } : {
            type : searchParams.get("type"),
            academic_year : selectedFilterParams.academic_year,
            academic_year_id: selectedAYID  ,
            start_date : startDate,
            end_date : endDate,
            class_name : selectedFilterParams.class,
            class_id:  selectedClassID ,
            section_name : selectedFilterParams.section,
            section_id:  selectedSectionID  ,
            page_number : 1,
            limit : 10,
            filter : true
        }
        if (searchParams.get("type") === "month") {
            obj["month"] = Object.values(selectedAY)?.length === 0 ? searchParams.get("month") : moment(selectedAY.start_date).format('MMM')
            obj["year"] = Object.values(selectedAY)?.length === 0 ? searchParams.get("year") : extractMonthYearInRange(selectedAY.start_date, selectedAY.end_date)[0].split(" ")[1]
            obj["start_date"] = startDate
            obj["end_date"] = endDate
        }
        const retainedSearchParams = Object.fromEntries([...searchParams.entries()]);
        // Conditionally add the 'search' parameter if it exists
        if (retainedSearchParams["search"]) {
            obj["search"] = retainedSearchParams["search"];
        }
        setSearchParams(obj)
    }
    /**
     * The function `handleOnClickMonthFilter` toggles the value of `isMonthFilter` if certain search
     * parameters are not null.
     */
    const handleOnClickMonthFilter = () => {
        if(type === "staff") {
            if(searchParams.get("financial_year") !== null  &&  searchParams.get("employee_type") !== null) {
                setIsMonthFilter(!isMonthFilter)
            }
        } else {
            if (searchParams.get("academic_year") !== null && searchParams.get("class_name") !== null && searchParams.get("section_name") !== null) {
                setIsMonthFilter(!isMonthFilter)
            }
        }
    }

    /**
     * The function `removeDateParameters` modifies URL search parameters by replacing and removing
     * specific keys based on certain conditions.
     * @returns The function `removeDateParameters` is returning the modified search parameters after
     * making the following changes:
     * 1. Replacing 'academic_year' with 'academic_year_id' and deleting 'academic_year'.
     * 2. Replacing 'class_name' with 'class_id' and deleting 'class_name'.
     * 3. Removing 'start_date' and 'end_date'.
     * 4. If the type is 'staff', then
     */
    const removeDateParameters = () => {
        let params = Object.fromEntries(searchParams);
        const modifiedSearchParams = new URLSearchParams(searchParams);
        // Iterate through each parameter and remove if the value is empty
        for (const [key, value] of modifiedSearchParams.entries()) {
            if (!value) {
                modifiedSearchParams.delete(key);
            }
        }
        // Replace academic_year with academic_year_id
        modifiedSearchParams.delete('academic_year');
        // Replace class_name with class_id
        modifiedSearchParams.delete('class_name');
        modifiedSearchParams.set('section_id', selectedSectionID);
        modifiedSearchParams.delete('section_name');
        // Remove start_date and end_date
        modifiedSearchParams.delete('start_date');
        modifiedSearchParams.delete('end_date');
        if (type === "staff") {
            modifiedSearchParams.set('staff_type', modifiedSearchParams.get('employee_type'));
            // If staff_type is null, delete it
            if (modifiedSearchParams.get('staff_type') === null || modifiedSearchParams.get('staff_type') === 'null'|| modifiedSearchParams.get('staff_type') === '') {
                modifiedSearchParams.delete('staff_type');
            }
            modifiedSearchParams.delete('employee_type');
            modifiedSearchParams.delete("fy_status");
            modifiedSearchParams.delete('section_id');

        }

        return modifiedSearchParams;
    };

    // Define the useCallback for getStudentAttendance
    const getStudentAttendance = useCallback(async () => {
        setRecodes({})
        if(searchParams.size<1){
            dispatch(resetState())
        }
        try {

            if (searchParams.get("page_number") !== null) {
                setLoading(true)
                const endPoint = removeDateParameters();
                const branch_id = await GetBranchId();
                //const res = await dataService.GetAPI(`student-attendance?branch_id=${branch_id}&${endPoint}`);
                dispatch(StudentsAttendance(`${type === "staff" ? "staff-attendance" : "student-attendance"}?branch_id=${branch_id}&${endPoint}`)).then((res)=>{
                    if(res?.payload?.data?.status===200){
                        dispatch(limitReducer([res?.payload?.data?.data,searchParams.get("limit"),searchParams.get("page_number")]))
                        setEmptyScreenMessage("")
                        setRecodes(res?.payload?.data?.data?.data)
                        if (searchParams.get("search")) {
                            if (Object.keys(recodes)?.length !== 0) {
                                const areEqual = res?.paylaod?.data?.data?.data?.length === recodes?.length && res?.payload?.data?.data?.data?.every((item, index) =>
                                    Object.keys(item).every(key => item[key] === recodes?.[index][key])
                                );
                                !areEqual && dispatch(onSearchRows([suggestions, res?.payload?.data?.data?.data, searchParams.get("page_number")]))
                            }
                        }
                    }
                    else{
                        setEmptyScreenMessage("No data found")
                    }
                })

                console.log(suggestions)
            }
        } catch (error) {
            setLoading(false);
            setRecodes({});
            setEmptyScreenMessage("No data found");
            // Handle the error as needed (e.g., show a message to the user).
        } finally{
            setTimeout(()=>{
                setLoading(false)

            }, 5000)
        }
        //setLoading(false)
    }, [searchParams]);

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            performSearch(e, suggestions);
        }
    };

    const clearAndperformSearch = (e) => {
        setSuggestions('');
        performSearch(e, '');
    }

    const performSearch = (e, val) => {
        val = (val == undefined ? suggestions : val);
        setSuggestions(val);
        optimizedFn('search', val)
    };

    const handleChange = (e) => {
        setSuggestions(e.target.value);
    };

    const performSearch1 = (key, val) => {
        handleSearchParams('search', val)
        if (val === "") {
            dispatch(onSearchRows([val, List, searchParams.get("limit"), searchParams.get("page_number")]))
        }
        setSuggestions(val);
    };

    const optimizedFn = useCallback(
        Debounce((key, value) => performSearch1(key, value)),
        [searchParams]
    );

    useEffect(() => {
        if (searchParams.get("type") === null || searchParams.get("type") === "month") {
            handleTabSwitch("month")
        } else if (searchParams.get("type") !== "year") {
            handleTabSwitch("month")
        } else {
            handleTabSwitch("year")
        }
        getStudentAttendance()
        setSuggestions(!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || '')
        setClearVisible(suggestions.length > 0);
        // optimizedFn()
    }, [getStudentAttendance]);

    const allLimits = ["10", "20", "30", "40", "50"]
    /**
     * The function `handleSearchParams` updates the search parameters object by adding or modifying a
     * key-value pair, and then sets the updated search parameters.
     */
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value);  }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }
    const tableContainerRef = useRef()
    /**
     * This function handles the click event of a page number and updates the search parameters with
     * the selected page number.
     */
    const handleOnClickPageNumber = (pageNum) => {
        tableContainerRef.current.scrollTop = 0;
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
        dispatch(addToTopCheckbox([pageNum.selected + 1, searchParams.get("limit")]))
    }
    const handleTabSwitch = (type) => {
        if (type !== searchParams.get("type")) {
            setSearchParams({ type: type })
            setRecodes({})
        }
    }
    const handleExport = async () => {
        try {

            if(loading || loadingExport)
            {
                return;
            }
            if(( (Object.keys(recodes)?.length === 0 || recodes?.total_count === 0)) || !(searchParams.size>1) || emptyScreenMessage==="No data found")
            {
                setToastErrorMessage("No records to export");
                return;
            }

            setLoadingExport(true);
            const modifiedSearchParams = new URLSearchParams(searchParams);
            modifiedSearchParams.delete('start_date');
            modifiedSearchParams.delete('end_date');
            modifiedSearchParams.delete('limit');
            modifiedSearchParams.delete("page_number");
            // Replace academic_year with academic_year_id
            modifiedSearchParams.delete('academic_year');
            // Replace class_name with class_id
            modifiedSearchParams.delete('class_name');
            modifiedSearchParams.set('section_id', selectedSectionID);
            modifiedSearchParams.delete('section_name');
            if (type === "staff") {
                modifiedSearchParams.set('staff_type', modifiedSearchParams.get('employee_type'));
                // If staff_type is null, delete it
                if (modifiedSearchParams.get('staff_type') === null || modifiedSearchParams.get('staff_type') === 'null'|| modifiedSearchParams.get('staff_type') === '') {
                    modifiedSearchParams.delete('staff_type');
                }
                modifiedSearchParams.delete('employee_type');
                modifiedSearchParams.delete("fy_status");
                modifiedSearchParams.delete('section_id');
            }
            const branch_id = await GetBranchId();
            const response = await dataService.GetAPI(`${type === "staff" ? "staff-attendance" : "student-attendance"}/export?branch_id=${branch_id}&${modifiedSearchParams}`);
            window.open(response.data.data.pre_signed_url);
            if (response.data.status === 200) {
                setToastmessage(response.data.data.message);
            }
        } catch (error) {
            console.error("Error occurred:", error);
            setLoadingExport(false);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoadingExport(false);
        }
    };

    function arraysAreEqual(arr1, arr2) {
        if (arr1?.length === undefined || arr2?.length === undefined) {
            return false
        }
        if (arr1?.length !== arr2?.length) {
            return false;
        }
        return arr1.every((item, index) => {
            const obj2 = arr2[index];
            return Object.keys(item).every(key => item[key] === obj2[key]);
        });

    }

    const holidayList = Array.isArray(List?.holiday_list) ? List.holiday_list : [];
    const holidayViewLabel = type !== "staff" &&
        searchParams.get("academic_year") !== null &&
        searchParams.get("class_name") !== null &&
        searchParams.get("section_name") !== null
        ? `AY: ${searchParams.get("academic_year")}, Class: ${searchParams.get("class_name")}, Section: ${searchParams.get("section_name")}`
        : '';


    return (
        <>
            <div className={` w-full main-screenInst overflow-x-hidden max-h-screen min-h-screen relative ${!isSideNavBar ? 'w-[270px] ' : ''}`} ref={tableContainerRef}>
                <div className={`mainDataCntnr ${!isSideNavBar ? 'normal' : 'wide'}`}>
                    <div className="mainDataCntnrTop shadow-s13" style={{ position: "sticky", position: "-webkit-sticky" }}>
                        <div className="flex items-center">
                            <h5 className="pageHeader adderror">{type === "staff" ? "Employee Attendance" : "Student Attendance"}</h5>
                        </div>
                    </div>
                    <div className="pb-10 relative">
                        {/* <!--Tabs navigation--> */}
                        <ul className="mr-4 ml-4 flex list-none flex-row flex-wrap border-b border-[#B3BBC1] pl-9 pt-6 bg-[#fff] sticky top-[64px] left-0 z-[10] -mx-1" role="tablist" data-te-nav-ref="">
                            <li role="presentation">
                                <p
                                    id='month'
                                    onClick={() => handleTabSwitch("month")}
                                    className={`${searchParams.get("type") === "month" ? "selected" : ""} tab-element mr-[126px]`}>
                                    Monthly
                                </p>
                            </li>
                            <li role="presentation">
                                <p
                                    id="year"
                                    onClick={() => handleTabSwitch("year")}
                                    className={`${searchParams.get("type") === "year" ? "selected" : ""} tab-element data-[te-nav-active]:font-semibold`}
                                >
                                    {type === "staff" ? "Financial Year" : "Academic Year"}
                                </p>
                            </li>
                        </ul>

                        {/* <!--Tabs content--> */}
                        <div className="scroll-bar tabbedPgListDiv">
                            <div className="hidden opacity-100 transition-opacity duration-150 ease-linear data-[te-tab-active]:block" id="tabs-institutionDetails" role="tabpanel" aria-labelledby="tabs-institutionDetails-tab" data-te-tab-active="">
                                <div className="flex items-center justify-end">
                                    <div className="relative ml-1" ref={filterRef}>
                                        <button
                                            onClick={(e) => { e.preventDefault(); setIsFilterOpen(!isFilterOpen) }}
                                            type="button" id="filter_btn" className="px-[18px] py-2.5 border border-[#106EB4] rounded-lg flex items-center">
                                            <img src="/images/Filter_Icon.svg" alt="img" className="w-[15px] h-[15px]" />
                                            <span className="text-f2 font-normal text-[#106EB4] pl-2.5">Filter</span>
                                            {(searchParams.get("academic_year") !== null && searchParams.get("class_name") !== null && searchParams.get("section_name") !== null) &&
                                                <p className="p-2 text-[14px] leading-[7px] font-normal text-[#FFFFFF] ml-2 bg-[#106EB4] rounded-[50%]">3</p>}
                                            {(searchParams.get("financial_year") !== null) &&
                                                <p className="p-2 text-[14px] leading-[7px] font-normal text-[#FFFFFF] ml-2 bg-[#106EB4] rounded-[50%]">
                                                    {(searchParams.get("employee_type") === '') ? 1 : 2}
                                                </p>}
                                        </button>

                                        {isFilterOpen && <Filter
                                            FilterArray={type === "staff" ? ["Financial Year", "Employee Type"] : ["Academic Year", "Class", "Section"]}
                                            setSearchParams={setSearchParams}
                                            setIsFilterOpen={setIsFilterOpen}
                                            setSelectedAYID={setSelectedAYID}
                                            selectedAYID={selectedAYID}
                                            selectedClassID={selectedClassID}
                                            setSelectedClassID={setSelectedClassID}
                                            setSelectedSectionID={setSelectedSectionID}
                                            searchParams={searchParams}
                                            handleClearFilter={handleClearFilter}
                                            handleApplyApi={handleApply}
                                            selectedFilterParams={type === "staff" ? selectedStaffFilterParams : selectedFilterParams}
                                            setSelectedFilterParams={type === "staff" ? setSelectedStaffFilterParams : setSelectedFilterParams}
                                            setSelectedAY={setSelectedAY}
                                            type={searchParams.get("type") === "year" && (searchParams.size <= 1 || (List?.data?.length === 0 || List?.total_count === 0 || emptyScreenMessage === "No data found"))}
                                            pageType={type}
                                        />}
                                    </div>
                                    {searchParams.get("type") === "month" && <div className="relative w-[150px]" ref={MonthFilterRef} style={{ 'margin-right': '0.4rem' }}>
                                        <button
                                            onClick={() => handleOnClickMonthFilter()}
                                            className={`sec_filter_btn ${(searchParams.get("month") === null && searchParams.get("year") === null) ? "bg-[#E6E8EA] text-[#818e98]" : "bg-[#FFF]"}`}
                                            type="button"
                                            id="month_filter"
                                        >
                                            <p className="w-[150px]" >{(searchParams.get("month") === null && searchParams.get("year") === null) ? "Select Month" : `${searchParams.get("month").slice(0, 3)} ${searchParams.get("year")}`}</p>
                                            <img loading="lazy" decoding="async" src="/images/dropdown-icon.png" alt="icon" className={`absolute top-[50%] -translate-y-[50%] dropdown-close right-2 ${isMonthFilter ? "transform rotate-180" : ""}`} />
                                        </button>
                                        {isMonthFilter && <MonthFilter
                                            searchParams={searchParams}
                                            setSearchParams={setSearchParams}
                                            setIsMonthFilter={setIsMonthFilter}
                                            getStudentAttendance={getStudentAttendance}
                                        />}
                                    </div>}
                                    {
                                        <div className="relative search-tab">
                                            <label htmlFor="input"></label>
                                            <div className="absolute top-[52%] -translate-y-[50%]" id='search_button'>
                                                <button
                                                    type="button"
                                                    id="search-button"
                                                    className="inline-block"
                                                    data-te-toggle="modal"
                                                    data-te-target="#exampleModalCenter"
                                                    data-te-ripple-init
                                                    data-te-ripple-color="light">
                                                    <img loading="lazy" decoding="async" src="/images/search.svg" alt="img"
                                                    />
                                                </button>
                                            </div>
                                            <div class="relative flex">
                                                <input
                                                    maxLength={90}
                                                    type="text"
                                                    id="search-value"
                                                    autoComplete='off'
                                                    value={suggestions}
                                                    // disabled={loading}
                                                    autoFocus={suggestions !== ""}
                                                    onChange={handleChange}
                                                    onKeyPress={handleKeyPress}
                                                    placeholder={type === "staff" ? "Employee Name / ID" : "Student Name / ID"} />
                                            </div>
                                            {isClearVisible && <div className='absolute cross_icon' id='clear_icon' onClick={clearAndperformSearch} title='Clear Seach'> </div>}
                                            {/* <!-- <button className="absolute top-[50%] -translate-y-[50%] right-3.5 inline-block">
                                    <img loading="lazy" decoding="async" src="images/search.svg" alt="img"/>
                                </button> --> */}

                                        </div>}

                                    {(searchParams?.get("type") === "month" || searchParams?.get("type") === "year") &&
                                        <button
                                            type="button"
                                            id='export'
                                            disabled={studentIds?.length > 0}
                                            onClick={() => handleExport()}
                                            className="prmy-btn export_btn"
                                        >   
                                            {loadingExport ? <Loader /> : "Export"}
                                        </button>}
                                    <>{hover === 'modify' &&
                                        <div className='relative top-12 left-[-60px]'>
                                            <TextSection text='Modify Attendance' show from={'academicreports'} />
                                        </div>}
                                    </>
                                    {searchParams.get("type") === "month" && (<div className="relative">
                                        <Link to={`${type === "staff" ? "/employee-master/employee-attendance" : "/student-master/student-attendance"}/modify-attendance?${searchParams.toString()}`}
                                            onClick={(e) => {
                                                if (type == 'staff') {
                                                    if (studentIds?.length === 0) {
                                                        e.preventDefault();
                                                        setToastErrorMessage("Select at least one employee");
                                                        return;
                                                    }
                                                    if (List?.financial_year_status !== "ongoing" && List?.financial_year_status !== "open") {
                                                        e.preventDefault();
                                                        setToastErrorMessage("FY is closed. Hence attendance cannot be modified");
                                                        return;
                                                    }
                                                    if (List?.clock_in_out) {
                                                        e.preventDefault();
                                                        setToastErrorMessage("Clock In/Clock out is enabled. Hence attendance cannot be modified");
                                                        return;
                                                    }
                                                }
                                                else {
                                                    if (studentIds?.length === 0) {
                                                        e.preventDefault();
                                                        setToastErrorMessage("Select at least one student");
                                                        return;
                                                    }
                                                    if (List?.academic_year_status === "completed") {
                                                        e.preventDefault();
                                                        setToastErrorMessage("AY completed. Hence attendance cannot be modified");
                                                        return;
                                                    }
                                                }
                                            }} >

                                            {!isInactiveBranch &&
                                            <button
                                                id="modify"
                                                className={`modify_icon bg-[#106eb4] hover:bg-[#1C8ADC]`}
                                                data-tooltip-target="panuploadInfo"
                                                data-tooltip-trigger="hover"
                                                data-tooltip-placement="top"
                                                type="button"
                                            >
                                                <img src="/images/edit-clipboard-svgrepo-com.svg" alt="icon" onMouseEnter={() => { sethover('modify') }}
                                                    onMouseLeave={() => { sethover('') }} />
                                            </button>}
                                        </Link>
                                        {/* <div id="panuploadInfo" role="tooltip" className="absolute z-10 w-max invisible inline-block left-[94px] text-[8px] leading-[12px] font-medium text-[#344054] px-1.5 py-1 bg-[#D0D5DD] rounded" data-popper-placement="top">
                                        Modify Attendance
                                        <div className="text-f7 font-semibold text-[#031624] ml-[26px] more-lines break-words max-w-[70%]" data-popper-arrow=""></div>
                                    </div> */}

                                    </div>)}
                                </div>
                                {type === "staff" ?
                                    <div className="mt-4 flex mb-2 justify-between">
                                        <div className="flex justify-end text-left">
                                            {(searchParams.get("financial_year") !== null && searchParams.get("employee_type") !== null) &&
                                                
                                                <p id='compare-text' className="w-full text-base font-normal text-[#031624]">
                                                    Displaying results for
                                                    {searchParams.get("financial_year") && (
                                                        <>
                                                            {" - "}
                                                            <span className="font-semibold">
                                                                {`${searchParams.get("financial_year")} (${searchParams.get("fy_status")?.charAt(0).toUpperCase() + searchParams.get("fy_status")?.slice(1)})`}
                                                            </span>
                                                        </>
                                                    )}
                                                    {searchParams.get("employee_type") && (
                                                        <>
                                                            {searchParams.get("financial_year") ? "," : " -"} Employee Type:
                                                            <span className="font-semibold"> {searchParams.get("employee_type")}</span>
                                                        </>
                                                    )}
                                                </p>
                                            }
                                        </div>
                                        <div className="flex text-right">
                                            <button
                                                type="button"
                                                className={`mr-4 font-normal text-[#052136] hover:underline '}`}
                                                onClick={() => setIsHolidayDialogOpen(true)}
                                                style={{ 'color': '#106eb4' }}>
                                                View Holiday List
                                            </button>
                                        

                                            {loading || ((List?.data?.length === 0 || List?.total_count === 0) || (searchParams.get("financial_year") === null || searchParams.get("employee_type") === null) || emptyScreenMessage === "No data found") ?
                                                <div className="flex text-right">
                                                    <p id='compare-text' className="w-full font-normal text-[#031624]">Teaching Employees:
                                                        <span className="font-semibold mr-4"> 0</span>Non-Teaching Employees: <span className="font-semibold">0</span>
                                                    </p>
                                                </div>
                                                :
                                                <div className="flex text-right">
                                                    <p id='compare-text' className="w-full font-normal text-[#031624]">Teaching Employees:
                                                        <span className="font-semibold mr-4">  {List?.teaching_count}</span>Non-Teaching Employees: <span className="font-semibold"> {List?.non_teaching_count}</span>
                                                    </p>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    :
                                    <div className="mt-4 flex items-center justify-between mb-2">
                                        <div className="flex justify-end items-center">
                                            {(searchParams.get("academic_year") !== null && searchParams.get("class_name") !== null && searchParams.get("section_name") !== null) &&
                                                <p id='compare-text' className="w-full font-normal text-[#031624]"><span>Displaying results for - </span>
                                                    <>
                                                        AY: <span className="font-semibold">  {searchParams.get("academic_year")}</span>, Class: <span className="font-semibold"> {searchParams.get("class_name")}</span>, Section: <span className="font-semibold"> {searchParams.get("section_name")}</span>
                                                    </>
                                                </p>
                                            }
                                        </div>
                                        
                                        <div className="flex justify-end items-center">
                                            <button
                                                type="button"
                                                className={`mr-4 font-normal text-[#052136] hover:underline '}`}
                                                onClick={() => setIsHolidayDialogOpen(true)}
                                                style={{'color':'#106eb4'}}
                                            >
                                                View Holiday List
                                            </button>
                                            <p className="font-normal text-[#052136]">Entries per page:</p>
                                            <ul className="flex items-center ml-2">
                                                {allLimits.map((item) => (
                                                    <li key={item + "limit"}>
                                                        <p
                                                            onClick={() => { if (searchParams.get("limit") !== item) handleSearchParams('limit', item) }}
                                                            className={`p-1 text-xs font-semibold cursor-pointer ${searchParams.get("limit") === item ? "text-[#EEF7FE] bg-[#106EB4]" : "text-[#052136]"} rounded mr-1`}>{item}</p>
                                                    </li>))}
                                            </ul>
                                        </div>

                                    </div>
                                }
                                {loading || (recodes?.length !== undefined && (!arraysAreEqual(List.data, recodes))) ? <ItemShimmer /> : searchParams.get("page_number") === null ?
                                    <>
                                        {searchParams.get("type") !== "month" ?
                                            <>
                                                <YearTable
                                                    recodes={[]}
                                                    searchParams={searchParams}
                                                    pageNumber={searchParams.get("page_number")}
                                                    pageType={type}
                                                    List={[]}
                                                    emptyScreenMessage={emptyScreenMessage}
                                                />
                                            </>
                                            :
                                            <>
                                                <Table
                                                    recodes={[]}
                                                    searchParams={searchParams}
                                                    tableContainerRef={tableContainerRef}
                                                    pageNumber={searchParams.get("page_number")}
                                                    limit={searchParams.get("limit")}
                                                    AY_status={List?.academic_year_status}
                                                    pageType={type}
                                                    List={[]}
                                                    emptyScreenMessage={emptyScreenMessage}
                                                />
                                            </>
                                        }
                                    </>
                                    :

                                    ((List?.data?.length === 0 || List?.total_count === 0 || emptyScreenMessage === "No data found") ?
                                        <>
                                            {searchParams.get("type") !== "month" ?
                                                <>
                                                    <YearTable
                                                        recodes={[]}
                                                        searchParams={searchParams}
                                                        pageNumber={searchParams.get("page_number")}
                                                        pageType={type}
                                                        List={[]}
                                                        emptyScreenMessage={emptyScreenMessage}
                                                    />
                                                </>
                                                :
                                                <>
                                                    <Table
                                                        recodes={[]}
                                                        searchParams={searchParams}
                                                        tableContainerRef={tableContainerRef}
                                                        pageNumber={searchParams.get("page_number")}
                                                        limit={searchParams.get("limit")}
                                                        AY_status={List?.academic_year_status}
                                                        pageType={type}
                                                        List={[]}
                                                        emptyScreenMessage={emptyScreenMessage}
                                                    />
                                                </>
                                            }
                                        </> :
                                        <>
                                            {searchParams.get("type") === "month" ? <Table
                                                recodes={List?.data}
                                                searchParams={searchParams}
                                                tableContainerRef={tableContainerRef}
                                                pageNumber={searchParams.get("page_number")}
                                                limit={searchParams.get("limit")}
                                                AY_status={List?.academic_year_status}
                                                pageType={type}
                                                List={List}
                                                emptyScreenMessage={emptyScreenMessage}
                                            /> : <YearTable
                                                recodes={List?.data}
                                                searchParams={searchParams}
                                                pageNumber={searchParams.get("page_number")}
                                                pageType={type}
                                                List={List}
                                                emptyScreenMessage={emptyScreenMessage}
                                            />}
                                            {(List?.total_count > Number(searchParams.get('limit'))) &&
                                                <div className='mt-4'>
                                                    <Pagination
                                                        TotalCount={List.total_count}
                                                        totalPageNumber={Math.ceil(List.total_count / Number(searchParams.get('limit')))}
                                                        selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                                                        handleOnClickPageNumber={handleOnClickPageNumber}
                                                        limit={Number(searchParams.get('limit'))}
                                                    />
                                                </div>
                                            }
                                        </>
                                    )
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {toastErrorMessage !== '' && <Toast
                message={toastErrorMessage}
                type="error"
                setToastmessage={setToastErrorMessage} />}
            <HolidayListDialog
                open={isHolidayDialogOpen}
                onClose={() => setIsHolidayDialogOpen(false)}
                holidayList={holidayList}
                viewLabel={holidayViewLabel}
                currentMonth={searchParams.get("month")}
                currentYear={searchParams.get("year")}
            />
        </>
    )
}

export default Attendance
